// import "../styles/Facilities.css";
// Removed unused office1 import
import office2 from "../Facilities/office2.png";
import printing from "../Facilities/p_12.jpeg";
import pantry from "../Facilities/p_13.jpeg";
import led from "../Facilities/p_14.jpeg";
// Removed unused img6, img7, img8, img9 imports
import conf from "../Facilities/conference.png";
import design from "../Facilities/designlab.png";
import bang1 from "../Facilities/officebangalore.png";
import bang2 from "../Facilities/bang2.png";
import work from "../Facilities/working-space.png";
import { FacilitiesList } from "./otherFacilities";

const facilities = [
  {
    img: conf,
    info1: "Conference Room",
  },
  {
    img: work,
    info1: "Co-Working Space at TBIF IITRPR",
  },
  {
    img: office2,
    info1: "Office Space at TBIF",
  },
  {
    img: bang1,
    info1: "Bangalore Office",
  },
  {
    img: bang2,
    info1: "Bangalore Office",
  },
  {
    img: pantry,
    info1: "24x7 Pantry service",
  },
  {
    img: printing,
    info1: "24x7 Printing service",
  },
  {
    img: led,
    info1: "55' interactive LED",
  },
  {
    img: design,
    info1: "Design Lab for building prototypes",
  },
];

function Facilities() {
  return (
    <div className="bg-white">
      <div className="pt-28 text-4xl font-bold font-montserrat text-black flex justify-center">
        <span className="text-blue-600">F</span>acilities
      </div>

      {/* Main facilities grid */}
      <div className="bg-white border-b border-black flex flex-col">
        <div className="border-b border-black px-6 md:px-20 py-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {facilities.map((facility, idx) => (
              <div
                key={idx}
                className="h-[450px] border border-blue-500 rounded-2xl bg-zinc-900 text-white cursor-pointer transform transition-transform duration-200 hover:scale-105 flex flex-col px-2  pt-10 sm:mx-2 mx-20"
              >
                <img
                  src={facility.img}
                  alt={facility.info1}
                  className="h-56 object-contain mb-4"
                />
                <h3 className="font-bold font-montserrat text-center">
                  {facility.info1}
                </h3>
              </div>
            ))}
          </div>
        </div>

        {/* Other facilities list */}
        <FacilitiesList/>
        {/* Additional support section */}
        <div>
          <div className="md:text-4xl text-3xl text-black flex justify-center font-bold font-mono text-center pt-6 pb-10">
            <div className="text-blue-600 pr-2">Additional</div>
            Support
          </div>

          <div className="font-sans text-black text-justify px-12 text-xl mb-10">
            <div>
              ● Access to the defence ecosystem through the{" "}
              <a
                className="font-montserrat font-bold text-blue-400"
                href=""
                target="_blank"
                rel="noopener noreferrer"
              >
                Center of Excellence for Studies and Applied Research in Defence
                & Security at IIT Ropar
              </a>{" "}
              – Facilitate defense related projects in Industry-Academia mode
              with startups as industry partners
            </div>

            <div className="mt-4">
              ● Supported by government funding schemes like{" "}
              <a
                className="text-blue-500 font-extralight"
                href="https://seedfund.startupindia.gov.in/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Startup Punjab Seed Fund
              </a>
              ,{" "}
              <a
                className="text-blue-500 font-extralight"
                href="https://msh.meity.gov.in/schemes/tide"
                target="_blank"
                rel="noopener noreferrer"
              >
                TIDE
              </a>
              ,{" "}
              <a
                className="text-blue-500 font-extralight"
                href=""
                target="_blank"
                rel="noopener noreferrer"
              >
                Incubator Own Funds
              </a>
              ,{" "}
              <a
                className="text-blue-500 font-extralight"
                href="https://msme.gov.in/"
                target="_blank"
                rel="noopener noreferrer"
              >
                MSME
              </a>
              ,{" "}
              <a
                className="text-blue-500 font-extralight"
                href="https://engineersindia.com/startup-india@eil"
                target="_blank"
                rel="noopener noreferrer"
              >
                EngSUI
              </a>
              ,{" "}
              <a
                className="text-blue-500 font-extralight"
                href="https://www.vcfsc.in/index.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                VCF-SC ST
              </a>
              etc. and Access to CSR funds.
            </div>

            <div className="mt-4">
              ● Matching investments in PPP model with VCs and angel investors
              like SucSEED, IvyCamp, India Accelerator
            </div>

            <div className="mt-4">
              ● Utilization the institute's equipment/infra at internal rates
              (20‑50x cheaper than rates for industry), can hire interns from
              institute.
            </div>

            <div className="mt-4">
              ● Facilitate forward area tours, exposure to defense related
              workshops and conference for startups.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Facilities;